import { baseApi } from "./baseApi";
const MERCHANT_BASE_URL = "/merchant";

export const merchantApi = baseApi.injectEndpoints({
  tagTypes: ["Merchant"],

  endpoints: (build) => ({
    addMerchant: build.mutation({
      query: (body) => ({
        url: MERCHANT_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Merchant", id: "LIST" }],
    }),
    listMerchants: build.query({
      query: (params) => ({
        url: MERCHANT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "Merchant",
                id: _id,
              })),
              { type: "Merchant", id: "LIST" },
            ]
          : [{ type: "Merchant", id: "LIST" }],
    }),
    getDDLMerchantList: build.query({
      query: (params) => ({
        url: `${MERCHANT_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({
                type: "Merchant",
                id: _id,
              })),
              { type: "Merchant", id: "DDL" },
            ]
          : [{ type: "Merchant", id: "DDL" }],
    }),
     getDDLMerchantListByTypes: build.query({
      query: (params) => ({
        url: `${MERCHANT_BASE_URL}/ddlByMerchantTypes`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({
                type: "Merchant",
                id: _id,
              })),
              { type: "Merchant", id: "DDL" },
            ]
          : [{ type: "Merchant", id: "DDL" }],
    }),
    getMerchantDetail: build.query({
      query: (merchantId) => `${MERCHANT_BASE_URL}/${merchantId}`,
      providesTags: (result, error, { _id }) => [
        { type: "Merchant", id: _id },
        { type: "Merchant", id: "LIST" },
      ],
    }),
    updateMerchant: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${MERCHANT_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "Merchant", id },
        { type: "Merchant", id: "LIST" },
      ],
    }),
   getTransactionsByMerchant: build.query({
      query: ({ merchantId, sortBy = 'createdAt', sortOrder = 'desc', search = '', page = 1, limit = 10 }) => ({
        url: `${MERCHANT_BASE_URL}/${merchantId}/transaction`,
        params: { sortBy, sortOrder, search, page, limit },
      }),
      providesTags: (result, error, { merchantId }) => [
        { type: "Merchant", id: merchantId },
        { type: "Merchant", id: "LIST" },
      ],
    }),
   
  }),
  overrideExisting: false,
});

export const {
  useListMerchantsQuery,
  useLazyListMerchantsQuery,
  useAddMerchantMutation,
  useLazyGetDDLMerchantListQuery,
  useLazyGetDDLMerchantListByTypesQuery,
  useGetMerchantDetailQuery,
  useUpdateMerchantMutation,
  useGetTransactionsByMerchantQuery,
} = merchantApi;